export default __webpack_public_path__ + "static/media/carousel2.1a141067.png";